(() => {
  const ROOT_SELECTOR = '[data-hr-orbit-nc-owned]';
  const PACKS = {
    '6': {
      optionRid: 'a2f62594-76c2-436f-b011-66e4c325762d',
      selectedClass: 'r-ch8xzz',
      buttonRid: '6e8ead22-ca8e-41b5-8b40-a98b146254c0',
      bonusQuantity: 3,
      bonusValue: 24,
    },
    '12': {
      optionRid: 'b2f4700c-685a-41a5-8063-301b24856eff',
      selectedClass: 'r-13a27fh',
      buttonRid: '2eb0a54d-7d16-4c14-8dc5-83297b8bd188',
      bonusQuantity: 6,
      bonusValue: 42,
    },
    '24': {
      optionRid: '176446bc-f5d5-40fc-b4c9-74941d7f0420',
      selectedClass: 'r-dfg75a',
      buttonRid: 'f9f561fd-8521-4540-adca-3c08b03dc969',
      bonusQuantity: 12,
      bonusValue: 72,
    },
  };
  const BONUS_STATE_RID = '0cdaa8cc-83fc-4d5a-ab6d-a5ec66576b91';
  const BONUS_STATE_CLASS = 'r-jlo8u9';
  const BONUS_SUMMARY_RID = '54c3f981-64ca-4aa0-a704-0e24db531603';
  const BONUS_BENEFIT_RID = '77d268a5-5a31-442a-bdc2-939755dc6ad4';
  const DORMANT_BONUS_STATES = [
    ['ccf54247-dffe-416c-b2aa-138a38bcfdb3', 'r-1ng0g8g'],
    ['f9e0959c-dde6-4b09-98c7-505014846c66', 'r-ctzsq4'],
  ];
  const OFFER_TARGET_RID = '2b4a12fd-d467-44ac-88f8-0243f799bdb6';
  const OFFER_LINK_RIDS = [
    '149c7026-2614-4191-82c7-73fbd73f8e44',
    '7b101e14-396f-4886-8382-f394acc87e8c',
    '09e18f26-38f2-433b-9314-7bd17f64998f',
    '80c9745d-2f18-4a4c-869c-46a5b6915231',
  ];
  const BACK_TO_TOP_RID = '2422b70d-08f9-429f-9233-b83558a95f64';
  const LEARN_MORE_LINKS = {
    '10ff7a14-e54f-43d4-98b3-836dce1476c4': 'rush',
    '37041acc-ea4b-491d-8c79-483f4ea29177': 'vibe',
  };
  const MAIN_TRACK_TOKEN = 'R4vdqb2';
  const THUMBNAIL_TRACK_TOKEN = 'R1fdqb2';
  const THUMBNAIL_SELECTED_CLASS = 'r-1q4wjtb';
  const PRICE_RIDS = [
    '06a2eb15-1f46-4a52-b466-b9d913a770ac',
    '6618655c-9db2-47be-958c-e6654eb476b2',
  ];

  const byRid = (root, rid) => root.querySelector(`[data-rid="${rid}"]`);
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wait = (duration) => new Promise((resolve) => window.setTimeout(resolve, duration));

  const keyboardActivate = (element, callback) => {
    element.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      callback(event);
    });
  };

  const parseConfig = (root) => {
    try {
      return JSON.parse(root.querySelector('[data-hr-orbit-nc-config]')?.textContent || '');
    } catch (error) {
      console.error('[High Rider ORBIT NC] Invalid page configuration.', error);
      return null;
    }
  };

  const formatMoney = (cents, moneyFormat) => {
    const amount = Number(cents || 0) / 100;
    const withCommas = amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const format = moneyFormat || '${{amount}}';
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amount).toLocaleString('en-US'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas.replace(/,/g, 'X').replace(/\./g, ',').replace(/X/g, '.'))
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas);
  };

  const initializeCollapsibles = (root) => {
    root.querySelectorAll('[data-replo-collapsible="true"]').forEach((collapsible) => {
      if (collapsible.dataset.hrOrbitNcCollapsible === 'true') return;
      const trigger = Array.from(collapsible.children)
        .find((child) => child.matches('[role="button"][aria-controls]'));
      const panelId = trigger?.getAttribute('aria-controls');
      const panel = panelId ? root.querySelector(`#${CSS.escape(panelId)}`) : null;
      if (!trigger || !panel) return;

      collapsible.dataset.hrOrbitNcCollapsible = 'true';
      const setExpanded = (expanded) => {
        collapsible.dataset.state = expanded ? 'open' : 'closed';
        trigger.setAttribute('aria-expanded', String(expanded));
        panel.hidden = !expanded;
        panel.dataset.state = expanded ? 'open' : 'closed';
      };
      const toggle = () => setExpanded(trigger.getAttribute('aria-expanded') !== 'true');
      setExpanded(collapsible.dataset.state === 'open' && !panel.hidden);
      trigger.addEventListener('click', toggle);
      keyboardActivate(trigger, toggle);
    });
  };

  const initializeCarousel = (root) => {
    const carousel = root.querySelector('[data-replo-carousel="true"]');
    if (!carousel) return;
    const mainTrack = carousel.querySelector(`[data-replo-part="slide-track"][data-replo-root-id*="${MAIN_TRACK_TOKEN}"]`);
    const thumbnailTrack = carousel.querySelector(`[data-replo-part="slide-track"][data-replo-root-id*="${THUMBNAIL_TRACK_TOKEN}"]`);
    if (!mainTrack || !thumbnailTrack) return;

    const uniqueSlides = (track) => {
      const seen = new Set();
      return Array.from(track.children).filter((slide) => {
        const sourceIndex = slide.dataset.slideSourceIndex;
        if (sourceIndex === undefined || seen.has(sourceIndex)) return false;
        seen.add(sourceIndex);
        return true;
      });
    };
    const mainSlides = uniqueSlides(mainTrack);
    const thumbnailSlides = uniqueSlides(thumbnailTrack);
    const slideCount = Math.min(mainSlides.length, thumbnailSlides.length);
    if (!slideCount) return;
    mainTrack.replaceChildren(...mainSlides.slice(0, slideCount));
    thumbnailTrack.replaceChildren(...thumbnailSlides.slice(0, slideCount));

    const liveRegion = carousel.querySelector('[aria-live="polite"]');
    let activeIndex = 0;
    let touchStartX = null;
    const setActive = (index, focusThumbnail = false) => {
      activeIndex = (index + slideCount) % slideCount;
      mainTrack.style.transitionDuration = reducedMotion() ? '0ms' : '300ms';
      mainTrack.style.transitionProperty = 'transform';
      mainTrack.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;

      mainSlides.slice(0, slideCount).forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.removeAttribute('data-is-cloned');
        slide.dataset.isActive = String(active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.tabIndex = -1;
      });
      thumbnailSlides.slice(0, slideCount).forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.removeAttribute('data-is-cloned');
        slide.dataset.isActive = String(active);
        slide.setAttribute('role', 'button');
        slide.setAttribute('aria-label', `View product image ${slideIndex + 1}`);
        slide.setAttribute('aria-current', String(active));
        slide.tabIndex = active ? 0 : -1;
        slide.firstElementChild?.classList.toggle(THUMBNAIL_SELECTED_CLASS, active);
        if (active) {
          thumbnailTrack.parentElement?.scrollTo({
            left: slide.offsetLeft,
            behavior: reducedMotion() ? 'auto' : 'smooth',
          });
          if (focusThumbnail) slide.focus({ preventScroll: true });
        }
      });
      if (liveRegion) liveRegion.textContent = `Slide ${activeIndex + 1} of ${slideCount}`;
    };

    thumbnailSlides.slice(0, slideCount).forEach((slide, index) => {
      slide.addEventListener('click', () => setActive(index));
      keyboardActivate(slide, () => setActive(index));
      slide.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') setActive(0, true);
        else if (event.key === 'End') setActive(slideCount - 1, true);
        else setActive(index + (event.key === 'ArrowRight' ? 1 : -1), true);
      });
    });
    carousel.querySelector('[data-direction="previous"]')
      ?.addEventListener('click', () => setActive(activeIndex - 1));
    carousel.querySelector('[data-direction="next"]')
      ?.addEventListener('click', () => setActive(activeIndex + 1));
    carousel.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) >= 45) setActive(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });
    setActive(0);
  };

  const initializeNavigation = (root, config) => {
    const offer = byRid(root, OFFER_TARGET_RID);
    if (offer) {
      offer.id = offer.id || 'hr-orbit-nc-offer';
      offer.tabIndex = -1;
    }
    const scrollToOffer = (event) => {
      if (!offer) return;
      event?.preventDefault();
      offer.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    };
    OFFER_LINK_RIDS.forEach((rid) => {
      const control = byRid(root, rid);
      if (!control || !offer) return;
      control.setAttribute('role', 'link');
      control.setAttribute('aria-controls', offer.id);
      control.addEventListener('click', scrollToOffer);
      keyboardActivate(control, scrollToOffer);
    });

    const backToTop = byRid(root, BACK_TO_TOP_RID);
    if (backToTop) {
      const activate = (event) => {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: reducedMotion() ? 'auto' : 'smooth' });
      };
      backToTop.setAttribute('role', 'link');
      backToTop.addEventListener('click', activate);
      keyboardActivate(backToTop, activate);
    }

    Object.entries(LEARN_MORE_LINKS).forEach(([rid, routeKey]) => {
      const control = byRid(root, rid);
      const destination = config.routes?.[routeKey];
      if (!control || !destination) return;
      control.setAttribute('role', 'link');
      control.addEventListener('click', () => window.location.assign(destination));
      keyboardActivate(control, () => window.location.assign(destination));
    });

    root.addEventListener('click', (event) => {
      const badge = event.target.closest('.jdgm-preview-badge');
      if (!badge || !root.contains(badge)) return;
      const widget = root.querySelector('#judgeme_product_reviews') || document.getElementById('judgeme_product_reviews');
      if (!widget) return;
      event.preventDefault();
      widget.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    });
    root.querySelectorAll('.jdgm-preview-badge').forEach((badge) => {
      badge.setAttribute('role', 'link');
      badge.tabIndex = 0;
      badge.setAttribute('aria-controls', 'judgeme_product_reviews');
      keyboardActivate(badge, () => {
        const widget = root.querySelector('#judgeme_product_reviews') || document.getElementById('judgeme_product_reviews');
        widget?.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
      });
    });
  };

  const initializeProduct = (root, config) => {
    const options = Object.entries(PACKS).map(([pack, definition]) => ({
      pack,
      ...definition,
      element: byRid(root, definition.optionRid),
      button: byRid(root, definition.buttonRid),
    })).filter(({ element, button }) => element && button);
    if (!options.length) return;
    const variants = Array.isArray(config.variants) ? config.variants : [];
    const form = root.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const allSelectedClasses = Object.values(PACKS).map((pack) => pack.selectedClass);
    const bonusState = byRid(root, BONUS_STATE_RID);
    const bonusSummary = byRid(root, BONUS_SUMMARY_RID);
    const bonusBenefit = byRid(root, BONUS_BENEFIT_RID);
    const offerAvailable = config.offerAvailable !== false;
    const unavailableLabel = String(config.unavailableLabel || 'Unavailable');
    let selectedPack = '12';
    let selectedVariant = null;
    let loading = false;

    const variantForPack = (pack) => variants.find((variant) => (
      String(variant.options?.[0]) === String(pack)
      && String(variant.options?.[1]).toLowerCase() === 'berry'
    ));
    const currentButton = () => options.find(({ pack }) => pack === selectedPack)?.button;
    const setButtonLabels = (button, label) => {
      button.querySelectorAll('p').forEach((node) => {
        node.textContent = label;
      });
    };
    const setLoading = (isLoading) => {
      loading = offerAvailable && isLoading;
      options.forEach(({ button }) => {
        const isCurrentLoading = loading && button === currentButton();
        const canPurchase = offerAvailable && Boolean(selectedVariant?.available);
        button.dataset.hrLoading = String(isCurrentLoading);
        button.setAttribute('aria-busy', String(isCurrentLoading));
        button.toggleAttribute('disabled', isCurrentLoading || !canPurchase);
        button.setAttribute('aria-disabled', String(isCurrentLoading || !canPurchase));
        if (!offerAvailable) {
          setButtonLabels(button, unavailableLabel);
          return;
        }
        const loadingLabel = button.children[2]?.querySelector('p') || button.children[2];
        if (loadingLabel && isCurrentLoading) loadingLabel.textContent = 'Loading Cart...';
      });
    };
    const selectPack = (pack) => {
      const variant = variantForPack(pack);
      if (!variant) return;
      selectedPack = pack;
      selectedVariant = variant;
      root.dataset.hrPack = pack;
      if (variantInput) variantInput.value = String(variant.id);
      if (quantityInput) quantityInput.value = '1';
      DORMANT_BONUS_STATES.forEach(([rid, activeClass]) => {
        byRid(root, rid)?.classList.remove(activeClass);
      });
      bonusState?.classList.add(BONUS_STATE_CLASS);
      const bonusCopy = PACKS[pack];
      const summaryLines = bonusSummary?.querySelectorAll('p');
      if (summaryLines?.[0]) summaryLines[0].textContent = `${bonusCopy.bonusQuantity}x THC Energy Shots`;
      if (summaryLines?.[1]) summaryLines[1].textContent = `($${bonusCopy.bonusValue} Value)`;
      const benefitLine = bonusBenefit?.querySelector('p');
      if (benefitLine) benefitLine.textContent = `${bonusCopy.bonusQuantity} Free 20MG THC Shots`;
      PRICE_RIDS.forEach((rid) => {
        const price = byRid(root, rid);
        const target = price?.querySelector('span') || price;
        if (target) target.textContent = formatMoney(variant.price, config.moneyFormat);
      });
      options.forEach(({ pack: value, selectedClass, element, button }) => {
        const selected = value === pack;
        const canPurchase = offerAvailable && Boolean(variant.available);
        element.classList.remove(...allSelectedClasses);
        if (selected) element.classList.add(selectedClass);
        element.setAttribute('aria-selected', String(selected));
        element.tabIndex = selected ? 0 : -1;
        button.disabled = loading || !canPurchase;
        button.setAttribute('aria-disabled', String(loading || !canPurchase));
        if (!offerAvailable) setButtonLabels(button, unavailableLabel);
      });
    };

    options.forEach(({ pack, element }) => {
      element.addEventListener('click', () => selectPack(pack));
      keyboardActivate(element, () => selectPack(pack));
      element.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = options.findIndex((option) => option.pack === pack);
        const nextIndex = event.key === 'Home' ? 0
          : event.key === 'End' ? options.length - 1
            : (index + (event.key === 'ArrowRight' ? 1 : -1) + options.length) % options.length;
        selectPack(options[nextIndex].pack);
        options[nextIndex].element.focus();
      });
    });

    const requestJson = async (url, options) => {
      const response = await fetch(url, options);
      const body = await response.json().catch(() => ({}));
      if (!response.ok || body.status) {
        throw new Error(body.description || body.message || 'Unable to update your cart.');
      }
      return body;
    };
    const clearCart = () => requestJson(config.routes?.cartClear || '/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: '{}',
    });
    const applyDiscount = async (discount) => {
      const response = await fetch(`/discount/${encodeURIComponent(discount)}?redirect=/cart`, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error('Unable to apply this offer. Please try again.');
    };
    const addVariant = (variantId) => requestJson(config.routes?.cartAdd || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });
    const openEliteCart = async () => {
      let refreshRequested = false;
      for (let attempt = 0; attempt < 600; attempt += 1) {
        const backdrop = document.getElementById('EliteCartBackdrop');
        const dialog = Array.from(document.querySelectorAll('[role="dialog"]'))
          .find((candidate) => candidate.querySelector('.ec-cart-container') || candidate.closest('.ec-cart-container'));
        const backdropStyle = backdrop ? window.getComputedStyle(backdrop) : null;
        const backdropVisible = backdropStyle
          && backdropStyle.display !== 'none'
          && backdropStyle.visibility !== 'hidden';
        const dialogVisible = dialog
          && window.getComputedStyle(dialog).display !== 'none'
          && window.getComputedStyle(dialog).visibility !== 'hidden';
        if (backdropVisible || dialogVisible) return true;
        if (!refreshRequested && typeof window.EliteCart?.openDrawerWithDataRefresh === 'function') {
          refreshRequested = true;
          await window.EliteCart.openDrawerWithDataRefresh();
        }
        await wait(100);
      }
      return false;
    };
    const showError = (message) => {
      let error = root.querySelector('[data-hr-orbit-nc-error]');
      if (!error) {
        error = document.createElement('p');
        error.dataset.hrOrbitNcError = '';
        error.setAttribute('role', 'alert');
        currentButton()?.insertAdjacentElement('afterend', error);
      }
      error.textContent = message;
    };

    const addOffer = async (event) => {
      event.preventDefault();
      const offer = config.offers?.[selectedPack];
      if (!offerAvailable || loading || !selectedVariant?.available || !offer) return;
      setLoading(true);
      root.querySelector('[data-hr-orbit-nc-error]')?.remove();
      try {
        await clearCart();
        await applyDiscount(offer.discount);
        await addVariant(offer.giftVariantId);
        const cartData = await addVariant(selectedVariant.id);
        root.dispatchEvent(new CustomEvent('high-rider:cart-added', {
          bubbles: true,
          detail: {
            productId: config.productId,
            productHandle: config.productHandle,
            variantId: selectedVariant.id,
            giftVariantId: offer.giftVariantId,
            discountCode: offer.discount,
            cartData,
          },
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: { cartData, source: 'hr-orbit-nc-owned' },
        }));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'hr-orbit-nc-owned',
            productVariantId: String(selectedVariant.id),
            cartData,
          });
        }
        if (!await openEliteCart()) window.location.assign(config.routes?.cart || '/cart');
      } catch (error) {
        console.error('[High Rider ORBIT NC] Add to cart failed.', error);
        showError(error?.message || 'Unable to add this offer. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    if (offerAvailable) {
      options.forEach(({ button }) => button.addEventListener('click', addOffer));
      form?.addEventListener('submit', addOffer);
    } else {
      const blockUnavailableOffer = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
      };
      options.forEach(({ button }) => {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        setButtonLabels(button, unavailableLabel);
        button.addEventListener('click', blockUnavailableOffer, true);
      });
      form?.addEventListener('submit', blockUnavailableOffer, true);
    }
    selectPack(variantForPack('12')?.available ? '12' : options[0].pack);
  };

  const initialize = (root) => {
    if (root.dataset.hrOrbitNcInitialized === 'true') return;
    const config = parseConfig(root);
    if (!config) return;
    root.dataset.hrOrbitNcInitialized = 'true';
    initializeCollapsibles(root);
    initializeCarousel(root);
    initializeNavigation(root, config);
    initializeProduct(root, config);
  };
  const initializeAll = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) initialize(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initialize);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
